<template>
  <UserCommonLayout>
    <template #content>
      <LazyContestMain
        v-if="isLoading"
        :contest-list="contestListData"/>
    </template>
  </UserCommonLayout>
</template>

<script setup lang="ts">
import {computed, onMounted, ref} from "#imports";
import {LazyContestMain, UserCommonLayout} from '#components';
import {useNuxtApp} from "#app";
import {useContestService} from "~/composables/service/useContestService";
import {useLoadingStore} from "~/store/loading/loadingStore";
import {useI18n} from "vue-i18n";
import {ContestListModel} from "~~/package/mapper/contest/model/ContestListModel";

const { t } = useI18n();
const {$i18n} = useNuxtApp();
const lang = computed(() =>
    $i18n.locale.value.toUpperCase()
);

const contestListData = ref<ContestListModel[]>([]);
const isLoading = ref(false);
const loadingStore = useLoadingStore();

onMounted(() => {
  initData();
})

const initData = () => {
  Promise.all([useContestService().getContestList(lang.value)]).then(resolve => {
    contestListData.value = resolve[0];

    loadingStore.closeLoading();
    isLoading.value = !loadingStore.show;
  })
}

const getContestList = (lang: string) => {
  useContestService().getContestList(lang).then(contestList => {
    contestListData.value = contestList;
  })
}
</script>
